module.exports = __webpack_public_path__ + "assets/img/36_454_big.b1dbfd10.jpg";